import React from 'react';
import UserDiscipline from "../../../models/UserDiscipline";
import { Alert } from "antd";

// TODO: change text below to use TRANSLATIONS

const TalentAverageBill = ({ highlighted = true, disciplines = [], discipline, hourlyMarkUp = 0, forClient, experienceLevel, timingLayout }) => {

    if (TB.isNaN(hourlyMarkUp) || !(discipline?.id || disciplines?.length) || !laravel.discipline_categories) return null;

    const platformDisciplineRate = TB.max(
        TB.map(discipline ? [discipline] : disciplines, dis => {
            if (experienceLevel) {
                return UserDiscipline.rateForDisciplineByExp(dis.id, hourlyMarkUp, forClient, experienceLevel)
            } else {
                return UserDiscipline.rateForDiscipline(dis.id, hourlyMarkUp, forClient)
            }
        }
        ))

    let expLabel = experienceLevel ? (laravel.talent_experience_levels[experienceLevel]?.label || '6-10 years') : '6-10 years'

    // hide component if rate does not exist

    let shownDiscipline = discipline ? discipline.name : disciplines.length === 1 ? TB.first(disciplines).name : 'Roles';

    if (timingLayout) {
        return (
            <p className="text-sm">
                <strong>${Math.ceil(platformDisciplineRate)} per hour</strong> - The average rate on Wripple for the selected&nbsp;{shownDiscipline}&nbsp;with <span className="underline">{expLabel} of experience</span>
            </p>
        )
    }
    return (
        <div className="flex px-3 mt-4 mb-4">
            <Alert
                className={highlighted ? "avg-bill-alert" : "avg-bill-alert default"}
                message={(
                    <span>
                        The average rate on Wripple for the selected&nbsp;{shownDiscipline}&nbsp;with {expLabel} of
                        experience is <strong>${Math.ceil(platformDisciplineRate)} per hour</strong>.
                    </span>
                )}
                type="info"
                showIcon
            />
        </div>
    )
}

export default TalentAverageBill;